import * as React from 'react';
import * as Redux from 'redux';
import * as _ from 'lodash';
import { Contexts } from './contexts';
import { fetchResults, FetchResultsFlags } from '../../actions/results'
import { setSort, setSearchTerm, setPage, setAutocompleteActive, setActiveHit, updateSearchFacet, setMobileFacetsVisibility, setContext } from '../../actions/index';
import { ISearchAppState } from '../../reducers/index'
import { ISearchResult, IResults } from '../../state-helpers/search-results';
import { ISort } from '../../state-helpers/sorts';
import { ISearchCriteria } from '../../state-helpers/search-criteria';
import { IEpiProps } from '../../state-helpers/epi-props';
import { IPage } from '../../state-helpers/page';
import { Autocomplete } from './autocomplete';
import { IAutocompleteResults, IHit } from '../../state-helpers/autocomplete-results';
import { ResultsCountMessage } from '../../../global/components/results/results-count-msg';
import { addUrlProps, UrlQueryParamTypes, subquery, multiPushInUrlQuery, pushInUrlQuery } from 'react-url-query';
import { connect } from 'react-redux';
import { ContextIds, ISearchContext } from '../../../global/models/search-context';
import { bindActionCreators } from 'redux';
import { fetchAutocompleteResults } from '../../actions/autocomplete-results';
import { IFacetResult } from '../../state-helpers/facets';
import { Suggestion } from './suggestion';
import { AdvancedSearchMenu } from './advanced-search-menu';
import { IAnalytics } from '../../../global/functions/analytics';
import { hasNonAsciiCharacters } from '../../../global/functions/validation';

interface IStateProps {
    loading: boolean;
    suggestion: string;
    searchTerm: string;
    totalResults: number;
    pageModel: IPage;
    visibleResults: ISearchResult[];
    selectedContext: ISearchContext;
    autocompleteResults: IAutocompleteResults
    epiProps: IEpiProps;
}

interface IDispatchProps {
    setActiveHit: (index: number) => void;
    setSearchTerm: (term: string) => void;
    setPage: (page: number) => void;
    fetchResults: (flags: FetchResultsFlags) => void;
    setAutocompleteActive: (active: boolean) => void;
    fetchAutocompleteResults: (searchTerm: string) => void;
    updateSearchFacet: (facets: IFacetResult[]) => void;
    setMobileFacetsVisibility: (visible: boolean) => void;
}

interface IOwnProps {
    searchContexts: ISearchContext[],
    onContextSelect: (contextId: string) => void;
    analytics: IAnalytics
}

type IProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    searchTerm: string;
    advancedMenuVisible: boolean
}

const MAX_CHARACTERS = 243; // BestBets triggers an error if term length exceeds this

export class SearchBar extends React.Component<IProps, IState> {

    state: IState = {
        searchTerm: '',
        advancedMenuVisible: false
    }

    componentWillMount() {
        this.setSearchTerm(this.defaultValue);
    }

    /**
     * Function to read search term from URL without reading state props
     */
    get defaultValue() {
        var query = window.location.search;
        var vars = query.split(/[\&\?/]/);

        for (var i = 0; i < vars.length; i++) {

            var pair = vars[i];

            if (_.startsWith(pair, "k=")) {
                return decodeURIComponent(pair.split('=')[1]);
            }
        }

        return this.state.searchTerm;
    }

    get placeHolderText(): string {
        const { selectedContext } = this.props; 
        if (typeof (selectedContext) != 'undefined' && selectedContext != null) {
            switch (selectedContext.id) {
                case ContextIds.all:
                    return this.props.epiProps.defaultPlaceholderText;
                case ContextIds.policy:
                    return this.props.epiProps.policyPlaceholderText;
                case ContextIds.advocacy:
                    return this.props.epiProps.advocacyPlaceholderText;
                case ContextIds.publication:
                    return this.props.epiProps.publicationsPlaceholderText;
                case ContextIds.members:
                    return this.props.epiProps.membersPlaceholderText;
                case ContextIds.poc:
                    return this.props.epiProps.patientCarePlaceholderText;
                case ContextIds.grants:
                    return this.props.epiProps.grantsPlaceholderText;
                case ContextIds.guidelines:
                    return this.props.epiProps.guidelinesPlaceholderText;
                case ContextIds.education:
                    return this.props.epiProps.educationPlaceholderText;
                case ContextIds.groups:
                    return this.props.epiProps.groupsPlaceholderText;
                case ContextIds.shop:
                    return this.props.epiProps.shopPlaceholderText;
                case ContextIds.resources:
                    return this.props.epiProps.resourcePlaceholderText;
                case ContextIds.initiatives:
                    return this.props.epiProps.initativesPlaceholderText;
                case ContextIds.programs:
                    return this.props.epiProps.programsPlaceholderText;
                case ContextIds.nicu:
                    return this.props.epiProps.nicuPlaceholderText;
                case ContextIds.healthyChildren:
                    return this.props.epiProps.healthyChildrenPlaceholderText;
                case ContextIds.newsReleases:
                    return this.props.epiProps.newsReleasesPlaceholderText;
                case ContextIds.redBookOnline:
                    return this.props.epiProps.redBookOnlinePlaceholderText;
                default: return this.props.epiProps.defaultPlaceholderText;
            }
        }
    }

    render() {
        return (
            <div>

                {this.renderAdvancedMenu()}

                <div className="search-bar">
                    <div className="search-bar-area">

                        

                        <div className="search-bar-area-input homepage-main-search">
                            <label className="hidden-label" htmlFor="txt_search">Search Text</label>

                            <input
                                type="text"
                                name="txt_search"
                                id="txt_search"
                                aria-label="Search Text"
                                value={this.state.searchTerm}
                                maxLength={MAX_CHARACTERS}
                                placeholder={this.placeHolderText}
                                onChange={this.onInputChange}
                                onKeyDown={this.onInputKeyDown}
                                onBlur={this.onBlur}
                                onFocus={this.onFocus} />


                            <svg className='magnifying-glass'>
                                <use xlinkHref="#info-magnifying-glass"></use>
                            </svg>

                            { this.renderClearInput() }
                            { this.renderAutocomplete() }

                        </div>
                        <button className="search-bar-area-btn" onClick={() => this.onSearch(this.state.searchTerm)}>Search</button>
                    </div>
                    <div className="search-bar-info">
                        <div>

                            <ResultsCountMessage
                                totalResults={this.props.totalResults}
                                pageResults={this.props.visibleResults.length}
                                pageSize={this.props.pageModel.pageSize}
                                currentPage={this.props.pageModel.page}
                                isLoading={this.props.loading}
                                resultsProps={this.props.epiProps}
                                customClasses={"search-bar-subtext search-bar-info-total"} />

                            <Suggestion
                                suggestion={this.props.suggestion}
                                epiProps={this.props.epiProps}
                                loading={this.props.loading}
                                onSuggestionClick={this.onSuggestionClick} />

                        </div>
                        <a className="advanced-search-keywords-link" id="advanced-search-keywords-open" onClick={this.onShowAdvancedMenu}>Advanced Search Tips</a>
                    </div>
                </div>
            </div>
        )
    }

    setSearchTerm = (searchTerm: string) => {
        this.setState({searchTerm});
    }

    renderAdvancedMenu = () => {
        if (!this.state.advancedMenuVisible) {
            return;
        }

        return <AdvancedSearchMenu analytics={this.props.analytics} epiProps={this.props.epiProps} onCloseClick={this.onHideAdvancedMenu} />
    }

    renderClearInput = () => {
        if (this.state.searchTerm.length === 0) {
            return;
        }

        return (
            <div className='search-bar-area-input-clear' onClick={this.onInputClear}>
                <svg><use xlinkHref="#icon-x-circle"></use></svg>
            </div>
        );
    }

    renderAutocomplete = () => {
        const { autocompleteResults } = this.props;

        if (!autocompleteResults.isActive || this.state.searchTerm.length < 3 || autocompleteResults.hits.length === 0) {
            return;
        }

        return (
            <Autocomplete
                searchTerm={this.state.searchTerm}
                autocompleteResults={this.props.autocompleteResults}
                onResultActive={this.onAutocompleteHover}
                onResultClick={this.onSearch}
                setSearchTerm={this.setSearchTerm}
            />

        )
    }

    onSearch = (term = null, fromAutocomplete = false) => {
        term = term || this.state.searchTerm;
        this.props.setSearchTerm(term);

        // Clear facets and set to first page on new search
        this.props.setPage(1);
        this.props.updateSearchFacet([]);
        this.props.setMobileFacetsVisibility(false);

        let fetchFlags = FetchResultsFlags.WithSuggestion;
        if (fromAutocomplete) {
            this.props.fetchAutocompleteResults(term);
            this.props.setActiveHit(-1);
            multiPushInUrlQuery({ context: ContextIds.all });

            fetchFlags |= FetchResultsFlags.FromAutocomplete;
        }
        this.props.fetchResults(fetchFlags);

        this.props.setAutocompleteActive(false);
        multiPushInUrlQuery({ k: term, page: '1' });
    }

    onInputChange = (e) => {
        // check if any characters are non-ascii
        // if so, don't allow them
        if (hasNonAsciiCharacters(e.target.value)) {
            return;
        }
        this.setSearchTerm(e.target.value);
        //TODO: Add autocomplete back in once CORS is working
        //this.props.fetchAutocompleteResults(e.target.value);
        //this.props.setAutocompleteActive(true);
    }

    onBlur = (e) => {
        if (this.props.autocompleteResults.activeHit == -1) {
            this.props.setAutocompleteActive(false);
        }
    }

    onFocus = (e) => {
        this.props.setAutocompleteActive(true);
    }

    onInputClear = (e) => {
        this.setSearchTerm('');
    }

    /// <summary>
    /// Intercepts special keys that handle autocomplete scrolling and selection
    /// </summary>
    onInputKeyDown = (e) => {
        const { autocompleteResults, setActiveHit } = this.props;

        switch (e.keyCode) {
            //Up arrow
            //Move selected autocomplete result up one
            case 38: {
                e.preventDefault();
                if (autocompleteResults.activeHit == -1) {
                    setActiveHit(autocompleteResults.hits.length - 1);
                } else {
                    setActiveHit(autocompleteResults.activeHit - 1);
                }
                break;
            }

            //Down arrow
            //Move selected autocomplete result down one
            case 40: {
                e.preventDefault();
                if (autocompleteResults.activeHit == autocompleteResults.hits.length - 1)
                    setActiveHit(-1);
                else
                    setActiveHit(autocompleteResults.activeHit + 1);
                break;
            }

            //Enter key
            //If an autocomplete option is selected, change the search text to that, otherwise submit
            case 13: {
                let term = this.state.searchTerm;

                if (autocompleteResults.activeHit > -1) {
                    term = this.props.autocompleteResults.hits[this.props.autocompleteResults.activeHit].query;
                    this.setSearchTerm(term);
                }

                this.props.setAutocompleteActive(false);
                this.onSearch(term, this.props.autocompleteResults.activeHit > -1);
            }
        }
    }

    onSuggestionClick = () => {
        const { suggestion, setPage, fetchResults, setAutocompleteActive } = this.props;

        this.setSearchTerm(suggestion);
        setPage(1);
        fetchResults(FetchResultsFlags.None);
        setAutocompleteActive(false);

        multiPushInUrlQuery({ k: suggestion, page: '1' })
    }

    onAutocompleteHover = (index: number) => {
        this.props.setActiveHit(index);
    }

    onShowAdvancedMenu = () => {
        this.setState({ advancedMenuVisible: true })
    }

    onHideAdvancedMenu = () => {
        this.setState({ advancedMenuVisible: false })
    }

};

const mapStateToProps = (state: ISearchAppState): IStateProps => ({
    epiProps: state.epiPropsModel,
    loading: state.resultsModel.loading,
    totalResults: state.resultsModel.totalNumber,
    visibleResults: state.resultsModel.searchItemList,
    pageModel: state.pageModel,
    suggestion: state.resultsModel.suggestion,
    searchTerm: state.searchTermModel,
    selectedContext: state.selectedSearchContext,
    autocompleteResults: state.autocompleteResultsModel
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => {
    return bindActionCreators({
        setSearchTerm,
        setPage,
        fetchResults: fetchResults(ownProps.analytics),
        setAutocompleteActive,
        fetchAutocompleteResults,
        updateSearchFacet,
        setMobileFacetsVisibility,
        setActiveHit
    }, dispatch);
}

export const ConnectedSearchBar = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(SearchBar);